import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ProjectService } from 'src/app/services/project.service';

@Component({
  selector: 'app-configuration-manager',
  templateUrl: './configuration-manager.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class ConfigurationManagerComponent implements OnInit {

  @ViewChild('ngForm') form!: NgForm;

  configurationController : ConfigurationService;
  constructor(configurationController : ConfigurationService,
    private modalService: ModalControlService,
    public projectService : ProjectService,
    public bsModalRef : BsModalRef
    ) {
    this.configurationController = configurationController;
  }

  ngOnInit(): void {
    this.configurationController.saveChangesState();
  }

  @HostListener('document:keydown.escape', ['$event']) 
  onEscape(event: KeyboardEvent) {
    this.cancelConfiguration(false); // escape key already hides the modal
  }

  cancelConfiguration(hideModal: boolean = true):void {
    this.clearSelection();
    hideModal? this.bsModalRef.hide(): false;
  }

  saveConfiguration():void {
    if (!this.projectService.projectEditable()) {
      this.cancelConfiguration();
      return;
    }
    this.configurationController.saveConfigurationPopup(this.form);
    this.bsModalRef.hide();
  }

  clearSelection(): void{
    this.configurationController.setSelectedRow(-1);
    this.configurationController.configurationList?.forEach(el => {
      el.isselected = false;
    });
  }

  selectRow(i : number): void{
    if(i != this.configurationController.getSelectedRow()){
      if(this.configurationController.getSelectedRow() >= 0 && this.configurationController.getSelectedRow() <= this.configurationController.configurationList.length){
        this.configurationController.configurationList[this.configurationController.getSelectedRow()].isselected = false;
      }
      this.configurationController.setSelectedRow(i);
      this.configurationController.configurationList[i].isselected = true;
    }
    else{
      var currentRow = this.configurationController.getSelectedRow();
      if(this.configurationController.configurationList[this.configurationController.getSelectedRow()].isselected){
        this.configurationController.setSelectedRow(-1);
      }
      this.configurationController.configurationList[currentRow].isselected = !this.configurationController.configurationList[currentRow].isselected;
    }
  }

  loadConfigurationsOfProject(projectId : number): void{
    this.configurationController.loadConfigurationsOfProject(projectId);
  }

  cloneConfiguration(): void {
    //TODO
  }

  activateConfiguration(): void{
    if(this.configurationController.getSelectedRow() < 0 || this.configurationController.getSelectedRow() > this.configurationController.configurationList.length){
      this.modalService.showMesssageModal('Select Configuration','You have to select at least 1 configuration to activate.');
      return;
    }
    var selectedConfig = this.configurationController.configurationList[this.configurationController.getSelectedRow()];
    if(selectedConfig.active){
      this.modalService.showMesssageModal("Configuration Manager", "The selected configuration is already activated.");
      return;
    }
    this.configurationController.activateConfiguration(selectedConfig.id).subscribe((data) => {
      if(data){
        this.loadConfigurationsOfProject(this.projectService.activeProject.id);
        this.modalService.showMesssageModal("Configuration Manager", "The selected configuration was activated successfully.");
      }else{
      this.modalService.showMesssageModal("Error occurred.", "Occurred an error on activating Configuration.");
      }
    }, (error) => {
      this.modalService.showMesssageModal("Error occurred.", "Occurred an error on activating Configuration.");
    });
  }

  deleteConfiguration(): void{
    if(this.configurationController.getSelectedRow() < 0 || this.configurationController.getSelectedRow() > this.configurationController.configurationList.length){
      this.modalService.showMesssageModal('Select Configuration','You have to select at least 1 configuration to delete.');
      return;
    }
    var selectedConfig = this.configurationController.configurationList[this.configurationController.getSelectedRow()];
    if(selectedConfig.active){
      this.modalService.showMesssageModal("Configuration Manager", "You must activate another configuration before delete this.");
      return;
    }
    this.configurationController.deleteConfiguration(selectedConfig.id).subscribe((data) => {
      if(data){
        this.loadConfigurationsOfProject(this.projectService.activeProject.id);
        this.modalService.showMesssageModal("Configuration Manager", "The selected configuration was deleted successfully.");
      }else{
      this.modalService.showMesssageModal("Error occurred.", "Occurred an error on deleting Configuration.");
      }
    }, (error) => {
      this.modalService.showMesssageModal("Error occurred.", "Occurred an error on deleting Configuration.");
    });
  }

}
